export const localeCompareBy =
  <T>(accessor: (item: T) => string) =>
  (a: T, b: T): number =>
    accessor(a).localeCompare(accessor(b), undefined, { sensitivity: "base" });
